import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Close",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Subtract",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.83464 0.0429688C2.18827 0.0429688 0.0429688 2.18827 0.0429688 4.83464V13.168C0.0429688 15.8143 2.18827 17.9596 4.83464 17.9596H13.168C15.8143 17.9596 17.9596 15.8143 17.9596 13.168V4.83464C17.9596 2.18827 15.8143 0.0429688 13.168 0.0429688H4.83464ZM11.8282 7.23438L11.2979 7.76471L10.0607 9.00195L11.2979 10.2392L11.8282 10.7695L10.7676 11.8302L10.2372 11.2999L9 10.0626L7.76237 11.3002L7.23204 11.8306L6.17138 10.7699L6.70171 10.2396L7.93934 9.00195L6.70171 7.76433L6.17138 7.234L7.23204 6.17334L7.76237 6.70367L9 7.94129L10.2372 6.70404L10.7676 6.17372L11.8282 7.23438Z",
			fill: ""
		})
	})
});
export default SvgClose;
